export var menuItems = {
  "data": [

    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-board",
      "iconf": "fill-board",
      "icony": "fa fa-home",
      "type": "link",
      "active": false
    },

    {
      "title": "eSIM",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icon-mobile",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/esim",
          "title": "eSIM Management",
          "type": "link",
          "active": false
        },
        {
          "path": "/upload_imei",
          "title": "Upload IMEI",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Acivation Request",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "fa fa-list-alt",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/new_activation",
          "title": "New Request",
          "type": "link",
          "active": false
        },
        {
          "path": "/view_activation",
          "title": "View Request",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Whitelisting",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-list",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/new_whitelist",
          "title": "New Request",
          "type": "link",
          "active": false
        },
        {
          "path": "/view_whitelist_request",
          "title": "View Request",
          "type": "link",
          "active": false
        },
        {
          "path": "/view_whitelisting",
          "title": "View Whitelisting",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "SIM Diagnosis",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-support",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/data_usage",
          "title": "Data Usage",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Reports",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icon-files",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/sim_report",
          "title": "Sim Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/activation_report",
          "title": "Activation Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/whitelist_report",
          "title": "Whitelist Report",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "path": "/settings",
      "title": "Settings",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icon-settings",
      "type": "link",
      "active": false
    },

  ]
}